const useScrollToTopOrBottom = ref => (scrollPosition: 'top' | 'bottom') => {
  ref.current?.scrollTo({
    top: scrollPosition === 'bottom' ? ref.current?.scrollHeight : 0,
    behavior: 'smooth'
  });
};

export default useScrollToTopOrBottom;
